import { DT } from "webscada-client";

/**
 * PLC标签点定义
 * 格式: tagName: [opcAddr, defaultValue?, precision?]
 * opcAddr 为 Kepware 完整 OPC Item ID: Channel.Device.Tag
 * 若要使用bit，则标签名不能含有下划线_ 
 * MEM中tags不能含有下划线，否则网页里无法解析（因为scada.ts用下划线来解析标签名）
 * 数据来源: Kepware EX 配置，按实际 Tag Name 映射
 */

export const tags = {
    MEM: {
        addr: "",
        tags: {
            lotID:      ["", ""] as DT<string>,
            recipeName: ["", ""] as DT<string>,
            batchSet: ["", 0] as DT<number>,
            weight1Set: ["", 0] as DT<number>,
            tolerance1Set: ["", 0] as DT<number>,
            weight2Set: ["", 0] as DT<number>,
            tolerance2Set: ["", 0] as DT<number>,
            weight3Set: ["", 0] as DT<number>,
            tolerance3Set: ["", 0] as DT<number>,
        }
    },
    Device1: {
        addr: "ws://127.0.0.1:3000",
        tags: {
            // ========== DB112 (1#系统) ==========
            // DINT/Long - 实时数据
            DB112_DBD4:   ["CH1.Device1.DB112_DBD4", 0] as DT<number>,
            DB112_DBD8:   ["CH1.Device1.DB112_DBD8", 0] as DT<number>,
            DB112_DBD12:  ["CH1.Device1.DB112_DBD12", 0] as DT<number>,
            DB112_DBD16:  ["CH1.Device1.DB112_DBD16", 0] as DT<number>,
            DB112_DBD20:  ["CH1.Device1.DB112_DBD20", 0] as DT<number>,
            // DWord - 位操作字
            DB112_DBW0:   ["CH1.Device1.DB112_DBW0", 0] as DT<number>,   // DI输入: bit2=入口阀压力, bit3=入口阀开到位, bit5=PD泵高料位
            DB112_DBW2:   ["CH1.Device1.DB112_DBW2", 0] as DT<number>,   // DQ输出: bit0~bit6=阀门/电机输出
            DB112_DBW68:  ["CH1.Device1.DB112_DBW68", 0] as DT<number>,  // 控制命令字1
            DB112_DBW69:  ["CH1.Device1.DB112_DBW69", 0] as DT<number>,  // 控制命令字2
            DB112_DBW198: ["CH1.Device1.DB112_DBW198", 0] as DT<number>, // 状态字1: bit3~bit7
            DB112_DBW199: ["CH1.Device1.DB112_DBW199", 0] as DT<number>, // 状态字2: bit0~bit7
            DB112_DBW200: ["CH1.Device1.DB112_DBW200", 0] as DT<number>, // 步骤字1: bit0~bit7
            DB112_DBW201: ["CH1.Device1.DB112_DBW201", 0] as DT<number>, // 步骤字2: bit0~bit1, bit5
            DB112_DBW330: ["CH1.Device1.DB112_DBW330", 0] as DT<number>, // 预留/其他

            // ========== DB212 (2#系统) ==========
            DB212_DBD4:   ["CH1.Device1.DB212_DBD4", 0] as DT<number>,
            DB212_DBD8:   ["CH1.Device1.DB212_DBD8", 0] as DT<number>,
            DB212_DBD12:  ["CH1.Device1.DB212_DBD12", 0] as DT<number>,
            DB212_DBW0:   ["CH1.Device1.DB212_DBW0", 0] as DT<number>,
            DB212_DBW2:   ["CH1.Device1.DB212_DBW2", 0] as DT<number>,
            DB212_DBW68:  ["CH1.Device1.DB212_DBW68", 0] as DT<number>,
            DB212_DBW69:  ["CH1.Device1.DB212_DBW69", 0] as DT<number>,
            DB212_DBW198: ["CH1.Device1.DB212_DBW198", 0] as DT<number>,
            DB212_DBW199: ["CH1.Device1.DB212_DBW199", 0] as DT<number>,
            DB212_DBW200: ["CH1.Device1.DB212_DBW200", 0] as DT<number>,
            DB212_DBW330: ["CH1.Device1.DB212_DBW330", 0] as DT<number>,

            // ========== DB312 (3#系统) ==========
            DB312_DBD4:   ["CH1.Device1.DB312_DBD4", 0] as DT<number>,
            DB312_DBD8:   ["CH1.Device1.DB312_DBD8", 0] as DT<number>,
            DB312_DBD12:  ["CH1.Device1.DB312_DBD12", 0] as DT<number>,
            DB312_DBD16:  ["CH1.Device1.DB312_DBD16", 0] as DT<number>,
            DB312_DBD20:  ["CH1.Device1.DB312_DBD20", 0] as DT<number>,
            DB312_DBW0:   ["CH1.Device1.DB312_DBW0", 0] as DT<number>,
            DB312_DBW1:   ["CH1.Device1.DB312_DBW1", 0] as DT<number>,
            DB312_DBW2:   ["CH1.Device1.DB312_DBW2", 0] as DT<number>,
            DB312_DBW68:  ["CH1.Device1.DB312_DBW68", 0] as DT<number>,
            DB312_DBW69:  ["CH1.Device1.DB312_DBW69", 0] as DT<number>,
            DB312_DBW198: ["CH1.Device1.DB312_DBW198", 0] as DT<number>,
            DB312_DBW199: ["CH1.Device1.DB312_DBW199", 0] as DT<number>,
            DB312_DBW200: ["CH1.Device1.DB312_DBW200", 0] as DT<number>,
            DB312_DBW201: ["CH1.Device1.DB312_DBW201", 0] as DT<number>,
            DB312_DBW330: ["CH1.Device1.DB312_DBW330", 0] as DT<number>,

            // ========== DB401 (配方控制) ==========
            // DINT/Long
            DB401_DBD2:   ["CH1.Device1.DB401_DBD2", 0] as DT<number>,   // 任务ID
            DB401_DBD6:   ["CH1.Device1.DB401_DBD6", 0] as DT<number>,   // 批数
            DB401_DBD10:  ["CH1.Device1.DB401_DBD10", 0] as DT<number>,
            DB401_DBD14:  ["CH1.Device1.DB401_DBD14", 0] as DT<number>,  // 1#输送次数
            DB401_DBD18:  ["CH1.Device1.DB401_DBD18", 0] as DT<number>,
            DB401_DBD22:  ["CH1.Device1.DB401_DBD22", 0] as DT<number>,  // 2#输送次数
            DB401_DBD26:  ["CH1.Device1.DB401_DBD26", 0] as DT<number>,
            DB401_DBD30:  ["CH1.Device1.DB401_DBD30", 0] as DT<number>,  // 3#输送次数
            // REAL/Float - 配方设定值
            DB401_DBD66:  ["CH1.Device1.DB401_DBD66", 0] as DT<number>,  // 1#重量设定
            DB401_DBD70:  ["CH1.Device1.DB401_DBD70", 0] as DT<number>,  // 1#误差设定
            DB401_DBD74:  ["CH1.Device1.DB401_DBD74", 0] as DT<number>,  // 2#重量设定
            DB401_DBD78:  ["CH1.Device1.DB401_DBD78", 0] as DT<number>,  // 2#误差设定
            DB401_DBD82:  ["CH1.Device1.DB401_DBD82", 0] as DT<number>,  // 3#重量设定
            DB401_DBD86:  ["CH1.Device1.DB401_DBD86", 0] as DT<number>,  // 3#误差设定
            DB401_DBD90:  ["CH1.Device1.DB401_DBD90", 0] as DT<number>,
            DB401_DBD94:  ["CH1.Device1.DB401_DBD94", 0] as DT<number>,
            DB401_DBD98:  ["CH1.Device1.DB401_DBD98", 0] as DT<number>,
            // DWord - 控制信号字: bit0=允许发送, bit1=发送完成, bit2~bit7=称量/输送信号
            DB401_DBW0:   ["CH1.Device1.DB401_DBW0", 0] as DT<number>,
        }
    }
} as const;

export type TagsConfig = typeof tags;
